module.exports = __webpack_public_path__ + "img/img_shichang.e045f545.png";